import { setToken, getToken, setUserAvatar, getUserAvatar } from '@/libs/util'
import { login, logout } from '@/api/personal'
import { infoQueryDetail } from '@/api/info'
export default {
  state: {
    token: getToken(),
    userAvatar: getUserAvatar(),
    userName: '',
    userInfo: {}
  },
  mutations: {
    setFillMore () {},
    setToken (state, token) {
      state.token = token
      setToken(token)
    },
    setUserAvatar (state, avatar) {
      state.userAvatar = avatar
      setUserAvatar(avatar)
    }
  },
  actions: {
    handleLogin ({ commit }, data) {
      return new Promise((resolve, reject) => {
        login(data)
          .then(res => {
            const data = res.data
            commit('setToken', data.accessToken)
            commit('setUserAvatar', data.headPortrait)
            resolve(data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    // 退出登录
    handleLogOut ({ state, commit }) {
      return new Promise((resolve, reject) => {
        logout({})
          .then(() => {
            commit('setToken', '')
            commit('setUserAvatar', '')
            localStorage.clear();
            resolve()
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    // 获取用户的所有基本信息
    getInfoDetail ({ state, commit }) {
      return new Promise((resolve, reject) => {
        infoQueryDetail({})
          .then(res => {
            state.userInfo = res.data.model || {}
            resolve(res.data.model)
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  }
}
